var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logout"},[_c('NavLogo',{staticClass:"nav-logo-mobile",attrs:{"size":"sm","light":true,"root":true}}),_c('LogoutCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }